import { render, staticRenderFns } from "./GenderForExecutives.vue?vue&type=template&id=967f999c&scoped=true"
import script from "./GenderForExecutives.vue?vue&type=script&lang=js"
export * from "./GenderForExecutives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f999c",
  null
  
)

export default component.exports